import type { GameEngine } from '../GameEngine';

export class SceneManager {
  private readonly gameEngine: GameEngine;

  public constructor(gameEngine: GameEngine) {
    this.gameEngine = gameEngine;
  }

  public get loadedSceneId(): number {
    return this.gameEngine.loadedSceneId;
  }

  public async loadScene(loadOrderOrName: number | string): Promise<void> {
    await this.gameEngine.loadScene(loadOrderOrName);
  }

  public togglePause(): void {
    this.gameEngine.togglePause();
  }

  public printGameData(): void {
    this.gameEngine.printGameData();
  }
}
